import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchMandals, assetUrl } from '../services/api';
import logo from '../assets/logo.png';
import CustomSelect from '../components/CustomSelect';
import './Mandals.css';

const areas = ['All Areas', 'Valsad City', 'Bulsar', 'Pardi', 'Vapi', 'Umargam', 'Dharampur', 'Kaprada', 'Navsari', 'Bilimora', 'Gandevi'];

export default function Mandals() {
  const [mandals, setMandals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [area, setArea] = useState('All Areas');
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchMandals()
      .then((data) => { if (!cancelled) { setMandals(data); setError(null); } })
      .catch(() => { if (!cancelled) setError('Could not load the mandal directory. Please try again later.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const filtered = mandals.filter((m) => {
    const matchSearch = m.name.toLowerCase().includes(search.toLowerCase()) || m.area.toLowerCase().includes(search.toLowerCase());
    const matchArea = area === 'All Areas' || m.area === area;
    const matchVerified = !verifiedOnly || m.verified;
    return matchSearch && matchArea && matchVerified;
  });

  return (
    <div className="mandal-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Valsad District</div>
          <h1>Mandal Directory</h1>
          <p>All registered Ganpati Mahotsav Mandal across Valsad district — find, connect and collaborate.</p>
        </div>
      </div>

      <section>
        <div className="container">
          {/* Filters */}
          <div className="mandal-filters card">
            <div className="filter-search">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                placeholder="Search by name or area..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <CustomSelect options={areas} value={area} onChange={setArea} />
            <label className="verified-toggle">
              <input type="checkbox" checked={verifiedOnly} onChange={(e) => setVerifiedOnly(e.target.checked)} />
              <span>Verified Only</span>
            </label>
          </div>

          {loading && (
            <div className="no-results">
              <div style={{ fontSize: '3rem' }}>⏳</div>
              <h3>Loading mandal directory...</h3>
            </div>
          )}

          {!loading && error && (
            <div className="no-results">
              <div style={{ fontSize: '3rem' }}>⚠️</div>
              <h3>{error}</h3>
            </div>
          )}

          {!loading && !error && (
            <>
              <div className="mandal-count">
                Showing <strong>{filtered.length}</strong> of {mandals.length} mandal
              </div>

              {/* Grid */}
              <div className="mandal-grid">
                {filtered.map((m) => (
                  <div key={m.id} className="mandal-card card">
                    <div className="mandal-header">
                      <div className="mandal-icon">
                        <img src={m.logoUrl ? assetUrl(m.logoUrl) : logo} alt={m.name} style={{ height: '48px', objectFit: 'contain' }} />
                      </div>
                      {m.verified && <span className="verified-badge">✓ Verified</span>}
                    </div>
                    <h3 className="mandal-name">{m.name}</h3>
                    <div className="mandal-meta">
                      <span>📍 {m.area}</span>
                      <span>📅 Est. {m.year}</span>
                      <span>👥 {m.members} members</span>
                    </div>
                    <div className="mandal-activities">
                      {m.activities.map((a) => (
                        <span key={a} className="activity-tag">{a}</span>
                      ))}
                    </div>
                    <div className="mandal-actions">
                      <Link to={`/mandals/${m.slug}`} className="btn-outline" style={{ fontSize: '0.85rem', padding: '8px 18px' }}>View Details</Link>
                    </div>
                  </div>
                ))}
              </div>

              {filtered.length === 0 && (
                <div className="no-results">
                  <div style={{ fontSize: '3rem' }}>🔍</div>
                  <h3>No mandal found</h3>
                  <p>Try adjusting your search or filter criteria.</p>
                </div>
              )}
            </>
          )}

          <div className="mandal-cta card">
            <div>
              <h3>Don't see your Mandal?</h3>
              <p>Register your Ganpati Mahotsav Mandal and join the Valsad network today — it's free!</p>
            </div>
            <Link to="/register" className="btn-primary">Register Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
